export default {
  props: {
    record: {
      type: Object | Promise,
      required: true
    },
    listConfig: {
      type: Object
    }
  },
  data: function () {
    return {
      showVideo: false,
      data: {}
    };
  },
  async mounted() {
    this.data = await this.record;
  },
  methods: {
    // helper method to get by dotnotation
    _get(object, path, defval = null) {
      if (typeof path === 'string') path = path.split('.');
      return path.reduce((xs, x) => (xs && xs[x] ? xs[x] : defval), object);
    },
    getText(listConfigAttributeName) {
      let text = undefined;
      if (typeof this.listConfig?.[listConfigAttributeName] === 'string') {
        // When list.[listConfigAttributeName] is a simple string
        if (this.data[this.listConfig?.[listConfigAttributeName]]) {
          text = this.data[this.listConfig?.[listConfigAttributeName]];
        }
      } else if (Array.isArray(this.listConfig?.[listConfigAttributeName])) {
        // When list.[listConfigAttributeName] is an array (without a template)
        let title = '';
        for (let i = 0; i < this.listConfig?.[listConfigAttributeName].length; i++) {
          if (this.data[this.listConfig?.[listConfigAttributeName][i]]) {
            const part = `${this.data[this.listConfig?.[listConfigAttributeName][i]]}`;
            title = part.split(',').join('#,#');
          }
        }
        text = title;
      }
      return text;
    }
  },
  computed: {
    title() {
      const title = this.getText('title');
      if (title) {
        return title;
      } else {
        // fallback to first value in each record
        return Object.values(this.data).pop();
      }
    },
    subtitle() {
      return this.getText('subtitle');
    },
    subtitle2() {
      return this.getText('subtitle2');
    },
    image() {
      if (typeof this.listConfig?.image === 'string') {
        // follow dotnotation, try to find the image
        let image = this._get(this.data, `${this.listConfig.image}._thumbnail`);
        if (image?.error) {
          image = this._get(this.data, `${this.listConfig.image}._default`);
        }
        if (!image?.error && !!image?.path) {
          return this.$store.state.sdk.getSignedUrl(image.path);
        } else {
          return '/img/grey.png';
        }
      }
    },
    video() {
      if (
        typeof this.listConfig?.video === 'string' &&
        this.data[this.listConfig.video].variations &&
        this.data[this.listConfig.video].variations._default &&
        this.data[this.listConfig.video].variations._default.path
      ) {
        // follow dotnotation, try to find the default video path
        let video = this._get(this.data, `${this.listConfig.video}.variations._default.path`);
        if (video) {
          return this.$store.state.sdk.getSignedUrl(video);
        }
      }
    }
  }
};
